import { colors } from '@dixa/lib-shared-tokens';

export const styles = {
  background: colors.neutral['000'],
  border: colors.neutral[200],
  element: colors.neutral[300],
  highlight: colors.purple[500],
};
